<template>
  <div>
    <h3>Help</h3>
    <iframe src="http://www.bpmnquickguide.com/quickguide/" scrolling="auto" frameborder="0" width="100%" height="700px"></iframe>
  </div>
</template>
<script>
  export default {
    name: 'help',
    data() {
      return {

      }
    },
    mounted() {
      // window.console.log(this.$root.$firebaseRefs.anArray.limitToLast(25))
      // window.console.log(this.$root.$firebaseRefs.anArray.limitToLast(25))

      this.$root.$firebaseRefs.anObject.once('value', function(snapshot) {
        window.console.log(snapshot.val())
      })
    }
  }
</script>



// WEBPACK FOOTER //
// Help.vue?5e851ad8